import { useState, useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/integrations/supabase/client";

export function useWhatsAppPhonePrompt() {
  const { user, userRole } = useAuth();
  const [shouldShow, setShouldShow] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    if (!user) {
      setIsChecking(false);
      return;
    }

    // Only apply to fans
    if (userRole !== "fan") {
      setIsChecking(false);
      return;
    }

    // Durable check: WhatsApp-created users are always exempt from phone prompt
    // Use user_metadata which persists even after email replacement
    const isWhatsAppAccount = user.user_metadata?.auth_provider === "whatsapp";
    if (isWhatsAppAccount) {
      setShouldShow(false);
      setIsChecking(false);
      return;
    }

    // Also check the synthetic email as a fallback (pre-email-verification state)
    const isWhatsAppEmail = user.email
      ?.toLowerCase()
      .endsWith("@wa.paystreem.app");
    if (isWhatsAppEmail) {
      setShouldShow(false);
      setIsChecking(false);
      return;
    }

    const checkVerification = async () => {
      const { data: profile } = await supabase
        .from("public_profiles")
        .select("verified_phone, auth_provider")
        .eq("id", user.id)
        .single();

      // If auth_provider is whatsapp in the DB, skip phone prompt
      if (profile?.auth_provider === "whatsapp") {
        setShouldShow(false);
      } else if (profile?.verified_phone) {
        setShouldShow(false);
      } else {
        setShouldShow(true);
      }
      setIsChecking(false);
    };

    checkVerification();
  }, [user, userRole]);

  const close = () => {
    setShouldShow(false);
  };

  return { shouldShow, isChecking, close };
}
